module.exports = __webpack_public_path__ + "static/img/shushiClick.e066dc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/shushiClick.png
// module id = Hwiz
// module chunks = 0